// extracted by mini-css-extract-plugin
module.exports = {"container":"coinheading_container__2qxMx","heading":"coinheading_heading__3jL1b"};